(function () {
  "use strict";

  var rootPrefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var busy = false; /* lock to prevent concurrent SP cart operations */

  function sectionIds() {
    var ids = [];
    document.querySelectorAll("cart-items-component").forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  function cartHasSP(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.handle === "shipping-protection" || it.product_type === "Shipping Protection") return it;
    }
    return null;
  }

  /* Dispatch the Horizon cart:update event so the drawer + cart icon re-render.
     itemCount is the product-only count (SP excluded) and uses a non product-form
     source so cart-icon SETS (not adds) the bubble count. */
  function dispatchCartUpdate(sections, itemCount) {
    var ev = new Event("cart:update", { bubbles: true });
    ev.detail = {
      resource: {},
      sourceId: "shipping-protection",
      data: { source: "shipping-protection", itemCount: itemCount, sections: sections }
    };
    document.dispatchEvent(ev);
  }

  /* After an SP add/remove, fetch the authoritative cart, then re-render. */
  function settle(sections) {
    fetch(rootPrefix + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sp = cartHasSP(cart);
        var spQty = sp ? sp.quantity : 0;
        dispatchCartUpdate(sections, cart.item_count - spQty);
      })
      .catch(function () { dispatchCartUpdate(sections, undefined); });
  }

  function addSP(variantId, callback) {
    if (busy) { if (callback) callback(); return; }
    busy = true;

    fetch(rootPrefix + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartHasSP(cart)) { busy = false; if (callback) callback(); return; }

        var ids = sectionIds();
        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (ids.length) { body.sections = ids.join(","); body.sections_url = window.location.pathname; }

        return fetch(rootPrefix + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json(); })
          .then(function (addData) {
            busy = false;
            settle(addData && addData.sections);
            if (callback) callback();
          });
      })
      .catch(function (err) {
        console.error("[ec-sp] add error:", err);
        busy = false;
        if (callback) callback();
      });
  }

  function removeSP(callback) {
    if (busy) { if (callback) callback(); return; }
    busy = true;

    fetch(rootPrefix + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sp = cartHasSP(cart);
        if (!sp) { busy = false; if (callback) callback(); return; }

        var ids = sectionIds();
        var body = { id: sp.key, quantity: 0 };
        if (ids.length) { body.sections = ids.join(","); body.sections_url = window.location.pathname; }

        return fetch(rootPrefix + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json(); })
          .then(function (changeData) {
            busy = false;
            settle(changeData && changeData.sections);
            if (callback) callback();
          });
      })
      .catch(function (err) {
        console.error("[ec-sp] remove error:", err);
        busy = false;
        if (callback) callback();
      });
  }

  /* Toggle handler (event delegation so it survives drawer re-renders) */
  document.addEventListener("change", function (e) {
    var checkbox = e.target.closest && e.target.closest(".ec-sp-checkbox");
    if (!checkbox) return;
    var wrapper = checkbox.closest(".ec-sp");
    if (!wrapper) return;

    var variantId = parseInt(wrapper.getAttribute("data-sp-variant-id"), 10);
    if (!variantId) return;

    wrapper.classList.add("ec-sp--loading");
    if (checkbox.checked) {
      addSP(variantId, function () { wrapper.classList.remove("ec-sp--loading"); });
    } else {
      removeSP(function () { wrapper.classList.remove("ec-sp--loading"); });
    }
  });

  /* Default-ON: auto-add SP after a real product add (matches root-cause behavior).
     Only fires for genuine ATC events, never for our own SP events or qty changes. */
  document.addEventListener("cart:update", function (e) {
    var d = e.detail && e.detail.data;
    if (!d || d.source !== "product-form-component") return;
    var vid = window.ecSpVariantId;
    if (!vid) return;
    setTimeout(function () { addSP(vid); }, 300);
  });
})();
